<template>
	<card>
		<template slot="header">
			<h5 v-if="$slots.title || title" class="card-title">
				<slot name="title">
					{{title}}
				</slot>
			</h5>
		</template>
		<div>
			<div class="loading-spinner" v-if="isLoading">
				<vue-loaders-ball-spin-fade-loader color="white" scale="1.2"/>
			</div>
			<div class="ct-chart" v-else>
				<div v-if="seriesData.length ==0 ">
					You did not set any applience.
				</div>
				<v-chart class="chart" :option="option" v-else/>
			<!-- 	<div class="evaluation-text" v-if="periodTime !== 'year' && !!user && user.site === 'Brook Green'">
					Top 3 appliances make up {{ percent }}% of net usage.
				</div> -->
			</div>
		</div>
	</card>
</template>
<script>

import Card from "./Card.vue";
import { mapActions, mapGetters } from "vuex";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent
} from "echarts/components";
import VChart  from "vue-echarts";
import QuerySetting from '@/mixins/querySetting';

use([
	CanvasRenderer,
	BarChart,
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent
]);

export default {
	name: "appliance-card",
	mixins: [QuerySetting],
	props: {
		title: {
			type: String,
			default: ""
		}
	},
	components: {
		Card,
		VChart
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			user: 'auth/getUser',
			defaultSiteId: 'auth/getDefaultSiteId',
			defaultSiteName: 'auth/defaultSiteName'
		})
	},
	data() {
		return {
			isLoading: false,
			percent: 0,
			colorList: [
				'rgb(196, 103, 212)',
				'rgb(147, 38, 191)',
				'rgb(118, 37, 185)',
				'rgb(94, 36, 182)',
				'rgb(68, 36, 177)'
			],
			seriesData: [],
			tariff: {
				day: 0,
				night: 0,
				gen: 0
			},
			option: {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: 'white'
					},
					formatter: '{b}, {c}kWh'
				},
				grid: {
					width: '10%',
					height: '124%',
					top: 0,
					left: '50%'
				},
				xAxis: [
					{
						type: 'value',
						splitLine: {
							show: false,
						},
						splitNumber: 6
					}
				],
				yAxis: [
					{
						type: 'category',
						inverse: true,
						max: 5,
						data: [],
						animationDuration: 300,
						animationDurationUpdate: 300,
						axisLabel: {
							color: 'white',
							fontSize: 16,
							fontWeight: 10
						},
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						}
					}
				],
				series: [
					{
						realtimeSort: true,
						type: 'bar',
						barWidth: 40,
						barGap: '-100%',
						label: {
							color: 'white',
							fontSize: 14,
							precision: 1,
							position: 'right',
							fontFamily: 'Nunito Sans Light',
							show: true,
							valueAnimation: true,
							formatter: function(params) {
								return `${params.data.value}kWh / £${params.data.cost}` ;
							}
						},
						data: []
					}
				]
			}
		}
	},
	watch: {
		async periodTime(newValue) {
			await this.getTariff(this.user.siteId);
			this.getCostData(newValue);
		},
		async defaultSiteId(newValue) {
			await this.getTariff(this.user.siteId);
			this.getCostData(this.periodTime);
		}
	},
	async mounted() {
		await this.getTariff(this.user.siteId);
		if (this.user.rate == null) {
			this.$toasted.show("Please set rate first, you did not set rate.", {
				type: "error",
				duration: 2500,
			});
		}
		this.getCostData(this.periodTime);
		this.$nextTick(function () {
            window.setInterval(() => {
                this.getCostData(this.periodTime);
            },120000);
        });
	},
	methods: {
		...mapActions({
			getData: 'influx/getInfluxData',
			getApplience: 'influx/getApplience',
			getRates: "admin/getRates",
		}),
		async getTariff(site) {
			const rates = await this.getRates(site);
			this.tariff = {
				day: rates[rates.length - 1].cost_1,
				night: rates[rates.length - 1].cost_2,
				gen: rates[rates.length - 1].cost_3
			}
		},
		async getQueryResult(fields, genTypeDeviceOrders) {
			const data  = await this.getApplience(fields);
			let consumptionData = [];
			let loopData = [];

			if (data[0].length == 0) {
				loopData = data[1][0];
			} else {
				loopData = data[0][0];
			}
			
			Object.keys(loopData).forEach(key => {
				let dayData = 0;
				let nightData = 0;
				if (data[0].length == 0 || data[0][0][key] == null){
					dayData =  0;
				} else {
					dayData = parseFloat(data[0][0][key]);
				}


				if (data[1].length == 0 || data[1][0][key] == null){
					nightData =  0;
				} else {
					nightData = parseFloat(data[1][0][key]);
				}


				let item = null;

				if (genTypeDeviceOrders.includes(key)) {
					item = {
						device_order: key,
						power: Math.round((dayData + nightData + Number.EPSILON) * 100) / 100,
						cost: Math.round(((dayData + nightData) * this.tariff.gen + Number.EPSILON) * 100) / 100
					}
				} else {
					item = {
						device_order: key,
						power: Math.round((dayData + nightData + Number.EPSILON) * 100) / 100,
						cost: Math.round((dayData * this.tariff.day + nightData * this.tariff.night + Number.EPSILON) * 100) / 100
					}
				}
				consumptionData.push(item);
			});
			
			consumptionData.sort((a, b) => parseFloat(b.power) - parseFloat(a.power));
			return consumptionData;
		},
		async getCostData(value) {
			this.isLoading = true;
			this.option.series[0].data = [];
			this.option.yAxis[0].data = [];
			let powerData = [];
			let site = this.defaultSiteName !== '' ? this.defaultSiteName : this.user.site
			
			let devices = []
			let fields = '';
			let genTypeDevices = [];
			let genTypeDeviceOrders = [];

			for (let i = 0; i < this.user.devices.length; i++) {
				if (!!this.user.devices[i] && 
					this.user.devices[i]['device_type'] !== 'Voltage' &&
					this.user.devices[i]['device_type'] !== 'Frequency' &&
					this.user.devices[i]['applience'] == '1'
				) {
					if (this.user.devices[i]['device_type']  == 'Electricity Gen (Wh)') {
						genTypeDevices.push(this.user.devices[i]['device_name']);
						let itemOrder = 'device_' + this.user.devices[i]['device_order'];
						genTypeDeviceOrders.push(itemOrder);
					}
					fields += 'device_' + this.user.devices[i]['device_order'] + ','
				}
			}
			if (fields != '') fields = fields.slice(0, -1);
			let consumptionData = await this.getQueryResult(fields, genTypeDeviceOrders);

			for (let i = 0; i < 5; i++) {
				let device = this.user.devices.find(d => 'device_' + d.device_order == consumptionData[i]['device_order']);
				powerData.push({name: device['device_name'], value: consumptionData[i]['power'], cost: consumptionData[i]['cost']});
			}
			
			let seriesData = [];
			let displayNameData = [];

			powerData.map((item, index) => {
				if (genTypeDevices.includes(item.name)) {
					seriesData.push({
						value:item.value? item.value.toFixed(2):0, 
						itemStyle:{color: 'rgb(255,255, 0)'},
						cost: item.cost
					});
				} else {
					seriesData.push({
						value:item.value? item.value.toFixed(2):0, 
						itemStyle:{color:this.colorList[index]},
						cost: item.cost
					});
				}
				
				displayNameData.push({
					value: item.name,
					textStyle: {
						fontSize: 14
					}
				});
			});

			this.seriesData = seriesData;
			this.calcPercent(seriesData);
			this.option.series[0].data = seriesData;
			this.option.yAxis[0].data = displayNameData;
			this.isLoading = false;
		},
		calcPercent(data) {
			let first = 0.0;
			let total = 0.0;

			for (let i = 0; i < data.length; i++) {
				if (i < 3) {
					first += parseFloat(data[i].value);
				}
				total += parseFloat(data[i].value);
			}

			this.percent = (first / total * 100).toFixed(1);
		}
	}
};
</script>
<style lang="scss" scoped>
.evaluation-text {
	position: absolute;
	top: 65%;
	right: 0%;
	text-align: justify;
	font-size: 16px;
	width: 120px;
}
</style>
